import { render, staticRenderFns } from "./AddHuman.vue?vue&type=template&id=8f86b9d6&"
import script from "./AddHuman.vue?vue&type=script&lang=js&"
export * from "./AddHuman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports